export default "__VITE_ASSET__wDuAxFjo__"